import axios from "axios";
const instanceAPI = axios.create({
    baseURL: "https://androidpublisher.googleapis.com/androidpublisher/v3/applications/",
    headers:{
    "Content-Type": "application/json",
    //"signature":"wRdD5BqZQv0s125JMqLvinTxB7o",
    }
});
export {instanceAPI};